import { useSplitEnabled } from '@buffer-mono/features'
import { AlphaBadge, BetaBadge } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface SplitTagBadgeProps {
  /** Name of the Split.io split that gates the feature this badge sits next to. */
  splitName: string
  size?: 'small' | 'medium'
  className?: string
}

/**
 * Renders a Beta/Alpha badge driven by the split's tag in Split.io. Renders
 * nothing if the split isn't tagged alpha/beta, the SDK isn't ready, or the
 * organization isn't in the split — so the badge never marks a feature the
 * user can't access.
 */
export function SplitTagBadge({
  splitName,
  size = 'small',
  className,
}: SplitTagBadgeProps): JSX.Element | null {
  const { isEnabled, isReady, tag } = useSplitEnabled(splitName)

  if (!isReady || !isEnabled || tag === null) {
    return null
  }

  if (tag === 'alpha') {
    return <AlphaBadge size={size} className={className} />
  }

  return <BetaBadge size={size} className={className} />
}
